import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { API_BASE } from '../../lib/utils';
import { toast } from 'sonner';

const Users = () => {
  const [users, setUsers] = useState({ apprentices: [], employers: [] });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      const response = await axios.get(`${API_BASE}/admin/users`);
      setUsers(response.data);
    } catch (error) {
      console.error('Failed to fetch users:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="p-8 flex items-center justify-center"><div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#0D9488]"></div></div>;
  }

  return (
    <div className="p-4 sm:p-8">
      <div className="max-w-6xl mx-auto">
        <h1 className="text-3xl sm:text-4xl font-bold mb-6 sm:mb-8 text-[#1d1d1f] break-words">User Management</h1>

        {/* Apprentices */}
        <div className="mb-8">
          <h2 className="text-xl sm:text-2xl font-semibold mb-4 text-[#1d1d1f]">Apprentices ({users.apprentices.length})</h2>
          <div className="bg-white border border-[#d2d2d7] rounded-2xl sm:rounded-3xl overflow-hidden">
            <div className="overflow-x-auto">
              <table className="w-full min-w-[600px]">
              <thead className="bg-slate-50 border-b border-slate-200">
                <tr>
                  <th className="text-left p-4 font-semibold text-slate-700">Name</th>
                  <th className="text-left p-4 font-semibold text-slate-700">Location</th>
                  <th className="text-left p-4 font-semibold text-slate-700">Paid</th>
                  <th className="text-left p-4 font-semibold text-slate-700">Readiness</th>
                  <th className="text-left p-4 font-semibold text-slate-700">Status</th>
                </tr>
              </thead>
              <tbody>
                {users.apprentices.map((apprentice, idx) => (
                  <tr key={idx} className="border-b border-slate-100 hover:bg-slate-50">
                    <td className="p-4">{apprentice.name}</td>
                    <td className="p-4 text-slate-600">{apprentice.location}</td>
                    <td className="p-4">
                      <span className={`px-2 py-1 rounded-full text-xs font-medium ${
                        apprentice.has_paid ? 'bg-green-100 text-green-700' : 'bg-slate-100 text-slate-700'
                      }`}>
                        {apprentice.has_paid ? 'Paid' : 'Unpaid'}
                      </span>
                    </td>
                    <td className="p-4 font-semibold">{apprentice.readiness_score}/100</td>
                    <td className="p-4">
                      <span className={`px-2 py-1 rounded-full text-xs font-medium ${
                        apprentice.assessments_completed ? 'bg-green-100 text-green-700' : 'bg-orange-100 text-orange-700'
                      }`}>
                        {apprentice.assessments_completed ? 'Active' : 'Pending'}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            </div>
          </div>
        </div>

        {/* Employers */}
        <div>
          <h2 className="text-xl sm:text-2xl font-semibold mb-4 text-[#1d1d1f]">Employers ({users.employers.length})</h2>
          <div className="bg-white border border-[#d2d2d7] rounded-2xl sm:rounded-3xl overflow-hidden">
            <div className="overflow-x-auto">
              <table className="w-full min-w-[600px]">
              <thead className="bg-slate-50 border-b border-slate-200">
                <tr>
                  <th className="text-left p-4 font-semibold text-slate-700">Company</th>
                  <th className="text-left p-4 font-semibold text-slate-700">Industry</th>
                  <th className="text-left p-4 font-semibold text-slate-700">Location</th>
                  <th className="text-left p-4 font-semibold text-slate-700">Subscription</th>
                </tr>
              </thead>
              <tbody>
                {users.employers.map((employer, idx) => (
                  <tr key={idx} className="border-b border-slate-100 hover:bg-slate-50">
                    <td className="p-4 font-medium">{employer.company_name}</td>
                    <td className="p-4 text-slate-600">{employer.industry}</td>
                    <td className="p-4 text-slate-600">{employer.location}</td>
                    <td className="p-4">
                      <span className={`px-2 py-1 rounded-full text-xs font-medium capitalize ${
                        employer.has_subscribed ? 'bg-green-100 text-green-700' : 'bg-slate-100 text-slate-700'
                      }`}>
                        {employer.has_subscribed ? employer.subscription_tier : 'None'}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Users;
